// eslint-disable-next-line no-restricted-imports
import { HttpClient } from '@angular/common/http';
import { Component, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChangelogItem } from '@shared/index';
import dayjs from 'dayjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { firstValueFrom } from 'rxjs';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { CodemirrorAiComponent } from '../../../../../../shared/components/ai-bot/utils/codemirror-ai/codemirror-ai.component';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { ChangeLogService } from '../../../../../../shared/services/change-log.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ShortyPipe } from 'src/app/shared/pipes/shorty.pipe';

@Component({
  selector: 'app-changelog-tab',
  imports: [FormsModule, ShortyPipe, ManualLinkComponent, HintComponent, CodemirrorAiComponent, TableModule, TagModule, ButtonModule, ToggleSwitchModule],
  templateUrl: './changelog-tab.component.html',
  styleUrl: './changelog-tab.component.scss'
})
export class ChangelogTabComponent {
  public dayjs = dayjs;
  protected modalRef?: BsModalRef;
  protected selectedItem: ChangelogItem | undefined;
  protected isGenerating = false;
  protected changeHistoryPlaceholder = $localize`:@@change-history-placeholder:Beschreibe hier die wichtigsten Änderungen am Bot.`;

  constructor(
    public changeLogService: ChangeLogService,
    public rss: RouteShareService,
    private http: HttpClient,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  protected openModal(moreInfo: TemplateRef<void>, item: ChangelogItem) {
    this.selectedItem = item;
    this.modalRef = this.modalService.show(moreInfo, { class: 'modal-lg' });
  }

  protected saveChangeHistory(text: string): void {
    this.rss.botConfig.changeHistory = text;
    void this.rss.saveBotConfigField('changeHistory');
  }

  protected toggleShowChangeHistory(): void {
    void this.rss.saveBotConfigField('showChangeHistory');
  }

  protected async generateWithAI(): Promise<void> {
    this.isGenerating = true;
    try {
      const result = await firstValueFrom(
        this.http.post<{ text: string; summary: string }>('/api/toolbox/bot/admin/generateChangeHistory', {
          botId: this.rss.botConfig._id,
          currentChangeHistory: this.rss.botConfig.changeHistory
        })
      );
      this.saveChangeHistory(result.text);
      if (result.summary) {
        this.toastr.success('GENERAL', result.summary, { timeOut: 10000 });
      }
    } finally {
      this.isGenerating = false;
    }
  }
}

